import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  fill1?: string;
  fill2?: string;
  onClick?: (e: MouseEvent) => void;
};
const DoubleBed = forwardRef<SVGSVGElement, Props>(
  ({ className, fill1 = "#9B5757", fill2 = "#B6917E", onClick }, ref) => (
    <svg
      width="18"
      height="18"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512.001 512.001"
      className={className}
      onClick={onClick}
      ref={ref}
    >
      <path
        fill={fill2}
        d="M385.345,248.174h-99.117c-16.694,0-30.228-13.533-30.228-30.228v-52.938
   c0-16.693,13.533-30.228,30.228-30.228h99.117c16.694,0,30.228,13.533,30.228,30.228v52.938
   C415.573,234.639,402.038,248.174,385.345,248.174z"
      />
      <path
        fill={fill1}
        d="M385.345,263.326h-99.117c-25.023,0-45.379-20.357-45.379-45.38v-52.938
   c0-25.023,20.357-45.38,45.379-45.38h99.117c25.023,0,45.38,20.357,45.38,45.38v52.938
   C430.725,242.969,410.366,263.326,385.345,263.326z M286.226,149.932c-8.311,0-15.074,6.763-15.074,15.075v52.938
   c0,8.313,6.763,15.075,15.074,15.075h99.117c8.313,0,15.075-6.763,15.075-15.075v-52.938c0-8.313-6.763-15.075-15.075-15.075
   H286.226z"
      />
      <path
        fill={fill2}
        d="M225.774,248.174h-99.117c-16.694,0-30.228-13.533-30.228-30.228v-52.938
   c0-16.693,13.533-30.228,30.228-30.228h99.117c16.694,0,30.228,13.533,30.228,30.228v52.938
   C256,234.639,242.467,248.174,225.774,248.174z"
      />
      <g>
        <path
          fill={fill1}
          d="M225.774,263.326h-99.117c-25.023,0-45.38-20.357-45.38-45.38v-52.938
       c0-25.023,20.359-45.38,45.38-45.38h99.117c25.023,0,45.379,20.357,45.379,45.38v52.938
       C271.152,242.969,250.797,263.326,225.774,263.326z M126.657,149.932c-8.313,0-15.075,6.763-15.075,15.075v52.938
       c0,8.313,6.763,15.075,15.075,15.075h99.117c8.311,0,15.074-6.763,15.074-15.075v-52.938c0-8.313-6.763-15.075-15.074-15.075
       H126.657z"
        />
        <path
          fill={fill1}
          d="M44.471,468.137c-0.544,0-1.089-0.009-1.635-0.029C18.816,467.255,0,447.438,0,422.994V251.669
       c0-22.677,18.45-41.127,41.127-41.127h429.748c22.677,0,41.127,18.45,41.127,41.127v172.026c0,24.505-19.936,44.441-44.441,44.441
       c-24.506,0-44.442-19.936-44.442-44.441v-37.145c0-8.369,6.785-15.152,15.153-15.152c8.367,0,15.152,6.784,15.152,15.152v37.145
       c0,7.794,6.343,14.136,14.137,14.136c7.794,0,14.136-6.341,14.136-14.136V251.669c0-5.967-4.855-10.822-10.822-10.822H41.127
       c-5.967,0-10.822,4.855-10.822,10.822v171.325c0,7.91,6.103,14.562,13.605,14.828c3.943,0.127,7.56-1.267,10.345-3.952
       c2.788-2.69,4.323-6.303,4.323-10.173v-37.145c0-8.369,6.785-15.152,15.153-15.152h277.732c8.367,0,15.152,6.784,15.152,15.152
       c0,8.369-6.785,15.152-15.152,15.152H88.883v21.992c0,12.171-4.825,23.527-13.583,31.979
       C66.938,463.747,56.043,468.137,44.471,468.137z"
        />
        <path
          fill={fill1}
          d="M471.165,240.084H40.834c-8.367,0-15.153-6.784-15.153-15.153v-78.787
       c0-56.398,45.883-102.279,102.281-102.279h23.485c8.367,0,15.152,6.784,15.152,15.153s-6.785,15.152-15.152,15.152h-23.485
       c-39.687,0-71.976,32.288-71.976,71.974v63.636h400.026v-63.636c0-39.687-32.288-71.974-71.976-71.974H238.325
       c-8.367,0-15.152-6.784-15.152-15.152s6.785-15.153,15.152-15.153h145.713c56.398,0,102.281,45.883,102.281,102.279v78.788
       C486.318,233.3,479.534,240.084,471.165,240.084z"
        />
      </g>
      <path
        fill={fill2}
        d="M496.848,305.246v-53.576c0-14.345-11.63-25.974-25.974-25.974H41.127
   c-14.345,0-25.974,11.63-25.974,25.974v53.576H496.848z"
      />
      <path
        fill={fill1}
        d="M496.848,320.398H15.153C6.785,320.398,0,313.614,0,305.246v-53.576
   c0-22.677,18.45-41.127,41.127-41.127h429.748c22.677,0,41.127,18.45,41.127,41.127v53.576
   C512,313.614,505.216,320.398,496.848,320.398z M30.305,290.093h451.39v-38.424c0-5.967-4.855-10.822-10.822-10.822H41.127
   c-5.967,0-10.822,4.855-10.822,10.822V290.093z"
      />
    </svg>
  ),
);

export default DoubleBed;
